import { apiClient } from "../apiClient";

export const lopApi = {
    getAll: () => apiClient.get(`lop`)
}